import React from "react";

const start = new Date("2017-01-01");
const now = new Date();

let years = now.getFullYear() - start.getFullYear();
const completedProjects = now.getFullYear() - 2010;

const achievementsContent = [
  { title: years, subTitle1: "years of", subTitle2: "experience" },
  { title: completedProjects, subTitle1: "completed", subTitle2: "projects" },
  { title: "8", subTitle1: "Hours/Day", subTitle2: "availability" },
  { title: "4", subTitle1: "awards", subTitle2: "won" },
];

const Achievements = () => {
  return (
    <div className="row">
      {achievementsContent.map((val, i) => (
        <div className="col-6" key={i}>
          <div className="box-stats with-margin">
            <h3 className="poppins-font position-relative">{val.title}</h3>
            <p className="open-sans-font m-0 position-relative text-uppercase">
              {val.subTitle1} <span className="d-block">{val.subTitle2}</span>
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Achievements;
